import axiosInstance from "@/axiosConfig";
import { getApiUrl } from "@/shared/utils/api";
import { CHANGELOGS_ENDPOINTS } from "../configs/endpoints";
import type {
  ChangelogDetailResponse,
  ChangelogLatestPopupResponse,
  ChangelogsListResponse,
} from "../types/changelog.types";

export class ChangelogsService {
  static async getChangelogs(params: {
    page?: number
    items?: number
  } = {}): Promise<ChangelogsListResponse> {
    const searchParams = new URLSearchParams();
    if (params.page) searchParams.set("page", String(params.page));
    if (params.items) searchParams.set("items", String(params.items));

    const query = searchParams.toString();
    const url = query
      ? `${CHANGELOGS_ENDPOINTS.GET_CHANGELOGS}?${query}`
      : CHANGELOGS_ENDPOINTS.GET_CHANGELOGS;

    const response = await axiosInstance.get<ChangelogsListResponse>(
      getApiUrl(url),
    );
    return response.data;
  }

  static async getChangelog(id: string): Promise<ChangelogDetailResponse> {
    const response = await axiosInstance.get<ChangelogDetailResponse>(
      getApiUrl(CHANGELOGS_ENDPOINTS.GET_CHANGELOG(id)),
    );
    return response.data;
  }

  static async getLatestPopup(): Promise<ChangelogLatestPopupResponse> {
    const response = await axiosInstance.get<ChangelogLatestPopupResponse>(
      getApiUrl(CHANGELOGS_ENDPOINTS.GET_LATEST_POPUP),
    );
    return response.data;
  }
}
